import { useEffect } from 'react';
import { LegalEntityType } from '@izettle/constants';
import { useUser } from '@izettle/react';
import { useService } from '../../hooks/use-service.js';
import { KnownService } from '../../providers/services.js';
import { jsx, Fragment } from 'react/jsx-runtime';

const requiresUpgrade = _ref => {
  let {
    organization
  } = _ref;
  return organization.customerStatus === "MINIMAL_SIGNUP";
};
const isAPerson = _ref2 => {
  let {
    organization
  } = _ref2;
  return organization.legalEntityType === LegalEntityType.Person;
};
const hasBetaFlag = flag => _ref3 => {
  let {
    organization
  } = _ref3;
  return organization.betaFeatures.includes(flag);
};
const canHaveEcommerce = userData => !isAPerson(userData) && hasBetaFlag("SelzAvailable")(userData);
const isECommerceUserWithoutKyc = userData => canHaveEcommerce(userData) && hasBetaFlag("MinimalEcomUser")(userData);
const getShouldRedirect = userData => requiresUpgrade(userData) && (!isECommerceUserWithoutKyc(userData) || userData.isMobileApp || !userData.organization.settings.ecomInterested?.isEcomInterested);
const composeRedirectHref = (registrationUrl, userData) => {
  const type = userData.isMobileApp && hasBetaFlag("upgrade_step_by_step")(userData) ? "upgrade_step_by_step" : "upgrade";
  const queryParams = new URLSearchParams({
    uuid: userData.organization.fullOrganizationUuid
  });
  return `${registrationUrl}/${userData.locale.country.toLowerCase()}/${type}?${queryParams.toString()}`;
};
const KycRedirect = _ref4 => {
  let {
    children,
    disableKycRedirect
  } = _ref4;
  const userData = useUser();

  // Replicating the portal flow for now,
  // revisit if we should use the new RegistrationWeb service
  const registrationUrl = useService(KnownService.OldRegistrationWeb);
  const shouldRedirect = !disableKycRedirect && getShouldRedirect(userData);
  useEffect(() => {
    if (shouldRedirect) {
      window.location.href = composeRedirectHref(registrationUrl, userData);
    }
  }, [shouldRedirect]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return !shouldRedirect ? /*#__PURE__*/jsx(Fragment, {
    children: children
  }) : null;
};

export { KycRedirect };
//# sourceMappingURL=kyc-redirect.js.map
